import languages from '../languages';
import { getHrefParam, getJSON, PASSPORT_HOST } from '../ultile';
const GET_GENERATE_TOKEN = 'uid_token_login/generate_token';
export const GET_TOKEN = 'getToken';
languages.init();

const initLanguage = () => {
  return languages.mapMutiples([
    'officialPay',
    'changeAccount',
    'copy',
    'lastRefresh',
    'second',
    // 'immediatelyRefresh',
    'frequently',
    'tokenIntro',
    'tokenIntro1',
    'tokenIntro2',
    'tokenLogin',
    'tokenTip',
    'tokenKey',
    'copy_success',
    'confirm',
    'tips',
  ]); // 这里输入在语言中定义的字段key
};

export default {
  state: {
    languages: initLanguage(),
  },
  getters: {},
  mutations: {},
  actions: {
    [GET_TOKEN]() {
      return getJSON(PASSPORT_HOST + GET_GENERATE_TOKEN, {
        gameId: getHrefParam('gameId'),
      });
    },
  },
};
